module.exports = __webpack_public_path__ + "static/embedded-software-561dabeef797a8a981d71016c6c5b7f5.jpg";